import { useEffect, useRef, useState } from "react";
import { useThrottledWidthObserver } from "./useThrottledWidthObserver";
/**
 * @returns A `ref` to attach on a div where you want the ellipsis.
 * The `hasButton` boolean is evaluated to true only when the inner content is too large to be displayed.
 * The `ellipsisStyle` object must be spread to the same div.
 *
 * **NB** you shoud manually specify a `max-height` attribute on that div.
 *
 * @param nbOfLines limits the contents of a block to the specified number of lines.
 */
export const useEllipsis = (nbOfLines) => {
    const ref = useRef(null);
    const [hasButton, setHasButton] = useState(false);
    const checkHasButton = () => {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            const shouldcheckHasButton = ref.current.scrollHeight > ref.current.clientHeight;
            setHasButton(shouldcheckHasButton);
        }
    };
    useEffect(() => {
        checkHasButton();
    }, []);
    // @ts-ignore
    useThrottledWidthObserver(ref, checkHasButton);
    const ellipsisStyle = {
        display: "-webkit-box",
        WebkitLineClamp: nbOfLines,
        WebkitBoxOrient: "vertical",
        whiteSpace: "pre-line",
        overflow: "hidden",
    };
    return {
        // @ts-ignore
        ref,
        hasButton,
        ellipsisStyle,
    };
};
